/**
 * Language Select Dropdown
 */
import Tooltip from '@material-ui/core/Tooltip';
import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {Dropdown, DropdownMenu, DropdownToggle} from 'reactstrap';
import {compose} from 'redux';
// actions
import {rtlLayoutAction, setLanguage} from '../../actions';

const LanguageProvider = ({rtlLayoutAction, setLanguage, locale, languages}) => {
    const [langDropdownOpen, toggleDropdown] = useState(false);
    const {t, i18n} = useTranslation();
    // function to toggle dropdown menu
    const toggle = () => {
        toggleDropdown(!langDropdownOpen);
    };

    /**
     * Rtl Layout Event Hanlder
     * Use to Enable rtl Layout
     * @param {*object} event
     */
    const rtlLayoutHanlder = (isTrue) => {
        const root = document.getElementsByTagName('html')[0];
        if (isTrue) {
            root.setAttribute('dir', 'rtl');
            document.body.classList.add('rtl');
        } else {
            root.setAttribute('dir', 'ltr');
            document.body.classList.remove('rtl');
        }
        rtlLayoutAction(isTrue);
    };

    // on change language
    const onChangeLanguage = (lang) => {
        toggleDropdown(false);
        setLanguage(lang);
        i18n.changeLanguage(lang.locale);
        if (lang.locale === 'ar' || lang.locale === 'he') {
            rtlLayoutHanlder(true);
        } else {
            rtlLayoutHanlder(false);
        }
    };

    return (
        <Dropdown
            nav
            className="list-inline-item language-dropdown tour-step-5"
            isOpen={langDropdownOpen}
            toggle={toggle}
        >
            <DropdownToggle caret nav className="header-icon language-icon">
                <Tooltip title="Languages" placement="bottom">
                    <img
                        src={require(`Assets/flag-icons/${locale.icon}.png`)}
                        className="mr-10"
                        width="25"
                        height="16"
                        alt="lang-icon"
                    />
                </Tooltip>
            </DropdownToggle>
            <DropdownMenu>
                <div className="dropdown-content">
                    <div className="dropdown-top d-flex justify-content-between rounded-top bg-primary">
                        <span className="text-white font-weight-bold">Languages</span>
                    </div>
                    <div className="scroller">
                        <ul className="list-unstyled mb-0 dropdown-list">
                            {languages.map((language, key) => (
                                <li key={key} onClick={() => onChangeLanguage(language)}>
                                    <a href="#" onClick={(e) => e.preventDefault()}>
                                        <img
                                            src={require(`Assets/flag-icons/${language.icon}.png`)}
                                            className="mr-10"
                                            width="25"
                                            height="16"
                                            alt="lang-icon"
                                        />
                                        {language.name}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </DropdownMenu>
        </Dropdown>
    );
};

// map state to props
const mapStateToProps = ({settings}) => {
    return settings;
};

export default compose(
    connect(mapStateToProps, {setLanguage, rtlLayoutAction})
)(LanguageProvider);
